import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, switchMap, of, catchError, throwError } from 'rxjs';
import { BaseRestApiService } from 'src/app/service/baseRestApiService.service';
import { UrlProviderService, EndPoints } from 'src/app/service/urlprovider.service';

@Injectable({
    providedIn: 'root'
})
export class ServiceAdministrationService extends BaseRestApiService {
    constructor(http: HttpClient, urlProvider: UrlProviderService) {
        super(http, urlProvider);
    }

    index(payload?: any): Observable<any> {
        return this.post<any>(EndPoints.serviceAdministration_Index, false, null, {
            regionId: payload.regionId,
            activeServicesOnly: payload.activeServicesOnly,
            disabledServicesOnly: payload.disabledServicesOnly,
            mpoServicesOnly: payload.mpoServicesOnly,
            enrollmentPeriods: payload.enrollmentPeriods,
            grades: payload.grades
        }).pipe(
            switchMap((result) => {
                const properties = Object.keys(result);
                properties.forEach((property) => {
                    if (['partyServices'].indexOf(property) >= 0) {
                        result[property] = JSON.parse(result[property]);
                    }
                });

                return of(result);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }   

    postIndex(payLoad:any):Observable<any>{
        return this.post<any>(EndPoints.serviceAdministration_Index,false,null,payLoad);
    }

    show(id: number): Observable<any> {
        return this.get<any>(EndPoints.serviceAdministration_Show, false, id).pipe(
            switchMap((result) => {
                const properties = Object.keys(result);
                properties.forEach((property) => {
                    if (['partyService'].indexOf(property) >= 0) {
                        result[property] = JSON.parse(result[property]);
                    }
                });

                return of(result);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }

    getStateServices(): Observable<any> {
        return this.post<any>(EndPoints.serviceAdministration_GetStateServices, false, null, {}).pipe(
            switchMap((result) => {
                const properties = Object.keys(result);
                properties.forEach((property) => {
                    if (['stateServices'].indexOf(property) >= 0) {
                        result[property] = JSON.parse(result[property]);
                    }
                });

                return of(result);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }

    getMeasurableProgramObjectives(): Observable<any> {
        return this.post<any>(EndPoints.serviceAdministration_GetMeasurableProgramObjectives, false, null, {}).pipe(
            switchMap((result) => {
                const properties = Object.keys(result);
                properties.forEach((property) => {
                    if (['measurableProgramObjectives'].indexOf(property) >= 0) {
                        result[property] = JSON.parse(result[property]);
                    }
                });

                return of(result);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }

    getFederalCategories(): Observable<any> {
        return this.post<any>(EndPoints.serviceAdministration_GetFederalCategories, false, null, {}).pipe(
            switchMap((result) => {
                const properties = Object.keys(result);
                properties.forEach((property) => {
                    if (['federalCategories'].indexOf(property) >= 0) {
                        result[property] = JSON.parse(result[property]);
                    }
                });

                return of(result);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }

    indexSSDPComponents(): Observable<any> {
        return this.get<any>(EndPoints.serviceAdministration_IndexSSDPComponents, null, null).pipe(
            switchMap((result) => {
                const properties = Object.keys(result);
                properties.forEach((property) => {
                    if (['ssdpComponents'].indexOf(property) >= 0) {
                        result[property] = JSON.parse(result[property]);
                    }
                });

                return of(result);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }

    indexServiceHours(): Observable<any> {
        return this.get<any>(EndPoints.serviceAdministration_IndexServiceHours, null, null).pipe(
            switchMap((result) => {
                const properties = Object.keys(result);
                properties.forEach((property) => {
                    if (['serviceHours'].indexOf(property) >= 0) {
                        result[property] = JSON.parse(result[property]);
                    }
                });

                return of(result);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }

    indexServiceCategories(): Observable<any> {
        return this.get<any>(EndPoints.serviceAdministration_IndexServiceCategories, null, null).pipe(
            switchMap((result) => {
                const properties = Object.keys(result);
                properties.forEach((property) => {
                    if (['serviceCategories'].indexOf(property) >= 0) {
                        result[property] = JSON.parse(result[property]);
                    }
                });

                return of(result);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }

    indexServiceProviders(): Observable<any> {
        return this.get<any>(EndPoints.serviceAdministration_IndexServiceProviders, null, null).pipe(
            switchMap((result) => {
                const properties = Object.keys(result);
                properties.forEach((property) => {
                    if (['serviceProviders'].indexOf(property) >= 0) {
                        result[property] = JSON.parse(result[property]);
                    }
                });

                return of(result);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }

    indexPartyServiceStatusTypes(): Observable<any> {
        return this.get<any>(EndPoints.serviceAdministration_IndexPartyServiceStatusTypes, null, null).pipe(
            switchMap((result) => {
                const properties = Object.keys(result);
                properties.forEach((property) => {
                    if (['partyServiceStatusTypes'].indexOf(property) >= 0) {
                        result[property] = JSON.parse(result[property]);
                    }
                });

                return of(result);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }

    create(payload?: any): Observable<any> {
        return this.post<any>(EndPoints.serviceAdministration_Create, false, null, { partyService: payload.partyService }).pipe(
            switchMap((result) => {
                return of(result);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }

    update(payload?: any): Observable<any> {
        return this.post<any>(EndPoints.serviceAdministration_Update, false, null, {
            partyService: payload.partyService,
            editedFields: payload.editedFields
        }).pipe(
            switchMap((result) => {
                return of(result);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }

    delete_(partyServiceID: number): Observable<any> {
        return this.post<any>(EndPoints.serviceAdministration_Delete, false, null, { partyServiceID: partyServiceID }).pipe(
            switchMap((result) => {
                return of(result);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }

    deleteCheck(partyServiceID: number): Observable<any> {
        return this.post<any>(EndPoints.serviceAdministration_DeleteCheck, false, null, { partyServiceID: partyServiceID }).pipe(
            switchMap((result) => {
                return of(result);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }

    toggleStatus(partyServiceID: number): Observable<any> {
        return this.post<any>(EndPoints.serviceAdministration_ToggleStatus, false, null, { partyServiceID: partyServiceID }).pipe(
            switchMap((result) => {
                return of(result);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }


}
